import { Alert, Stack, TextField, Typography } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { useForm } from 'react-hook-form';
import ModalTemplate from 'v2/components/Modal/ModalTemplate';
import useModalContext from 'v2/components/Modal/useModalContext';

interface FormValues {
  description: string;
}

interface Props {
  cardUuid: string;
  blockNfcCard: (reason: string, uuid: string) => Promise<void>;
  blockNfcCardLoading: boolean;
}

const BLOCK_CARD_FORM_ID = 'block-card-form';

const BlockCardModal: React.FC<Props> = ({ cardUuid, blockNfcCard, blockNfcCardLoading }) => {
  const { translation } = useTranslation();
  const { closeModal } = useModalContext();

  const { register, handleSubmit } = useForm<FormValues>({
    mode: 'onTouched',
    defaultValues: { description: '' }
  });

  const onSubmit = async ({ description }: FormValues) => {
    await blockNfcCard(description, cardUuid);
    closeModal();
  };

  return (
    <ModalTemplate
      title={translation.block}
      primaryAction={{
        label: translation.block,
        form: BLOCK_CARD_FORM_ID,
        dangerzone: true,
        loading: blockNfcCardLoading,
        id: 'block-card-confirm-button'
      }}
      secondaryAction={{ label: translation.cancel, id: 'block-card-cancel-button' }}
    >
      <Stack component="form" id={BLOCK_CARD_FORM_ID} onSubmit={handleSubmit(onSubmit)} noValidate spacing={3}>
        <Typography variant="body2">{translation.block_card_confirmation}</Typography>
        <TextField
          {...register('description')}
          id="description-input"
          variant="outlined"
          multiline
          label={translation.description}
          placeholder={translation.block_card_description_placeholder}
        />
        <Alert variant="standard" severity="info">
          <Stack>
            <Typography variant="subtitle2">{translation.please_synchronize_locks}</Typography>
            <Typography variant="body2">{translation.block_card_sync_required}</Typography>
          </Stack>
        </Alert>
      </Stack>
    </ModalTemplate>
  );
};

export default BlockCardModal;
